export default __webpack_public_path__ + "static/media/icon-report-page.14b1b901.png";